/**
 * Quản lý lưu trữ trạng thái đọc trong localStorage
 */
const STORAGE_KEY = 'fake_excel_last_chapter_url';

export class StorageService {
  static saveLastReadUrl(url) {
    if (url) {
      localStorage.setItem(STORAGE_KEY, url);
    }
  }

  static getLastReadUrl() {
    return localStorage.getItem(STORAGE_KEY);
  }
}
